import { defineComponent as c, ref as p, onMounted as g, watch as _, openBlock as t, createElementBlock as l, normalizeClass as u, Fragment as f, renderList as v, createElementVNode as d, toDisplayString as s, createCommentVNode as m } from "vue";
import { n as y } from "./chunks/index.browser.Vf83cH3M.js";
import { _ as b } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/CatalogRadio.css';const k = ["for"], V = ["checked", "disabled", "id", "name", "value", "onInput"], $ = { class: "catalog-radio__label" }, C = {
  key: 0,
  class: "catalog-radio__meta"
}, S = {
  key: 0,
  class: "catalog-radio__error"
}, I = /* @__PURE__ */ c({
  __name: "CatalogRadio",
  props: {
    /**
     * The currently selected value.
     */
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * The choices for the radio group.
     * Each choice has: value, label, and optional meta (right side text).
     */
    choices: {
      type: Array,
      required: !0
    },
    /**
     * The `name` attribute used to identify the radio group when submitting the form.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Unique identifier for the component.
     * If not provided, a random ID will be generated.
     */
    id: {
      type: String
    },
    /**
     * Indicates whether the radio group is disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * The error message to display.
     */
    error: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const o = p(e.id);
    return g(() => {
      _(
        o,
        (n) => {
          n || (o.value = y());
        },
        { immediate: !0 }
      );
    }), (n, r) => (t(), l("div", {
      class: u(["catalog-radio", { "catalog-radio--has-error": e.error }])
    }, [
      (t(!0), l(f, null, v(e.choices, (a, i) => (t(), l("label", {
        key: a.value,
        for: `${o.value}-${i + 1}`,
        class: u(["catalog-radio__item", { "catalog-radio__item--selected": a.value === e.modelValue }])
      }, [
        d("input", {
          checked: a.value === e.modelValue,
          disabled: e.disabled,
          id: `${o.value}-${i + 1}`,
          name: e.name,
          value: a.value,
          onInput: (q) => n.$emit("update:modelValue", a.value),
          type: "radio",
          class: "catalog-radio__input"
        }, null, 40, V),
        r[0] || (r[0] = d("span", { class: "catalog-radio__control" }, null, -1)),
        d("span", $, s(a.label), 1),
        r[1] || (r[1] = d("span", { class: "catalog-radio__leader" }, null, -1)),
        a.meta ? (t(), l("span", C, s(a.meta), 1)) : m("", !0)
      ], 10, k))), 128)),
      e.error ? (t(), l("p", S, s(e.error), 1)) : m("", !0)
    ], 2));
  }
}), R = /* @__PURE__ */ b(I, [["__scopeId", "data-v-27deeab3"]]);
export {
  R as default
};
